import React from 'react'
import { Link } from 'react-router-dom'
import './footer.css'

const socialIcons = [
    {
        icon: "bx bxl-facebook",
        targetLink: "https://www.facebook.com/102810945540731​"
    },
    {
        icon: "bx bxl-twitter",
        targetLink: "https://twitter.com/theoutletke​"
    },
    {
        icon: "bx bxl-instagram-alt",
        targetLink: "https://www.instagram.com/theoutletke"
    }
]

const policies = [
    {
        policy: "Terms and Conditions",
        route: "/terms-and-conditions"
    },
    {
        policy: "Covid Guidelines",
        route: "/covid-guidelines"
    },
    {
        policy: "Data Policy",
        route: "/data-policy"
    },
    {
        policy: "Payment Policy",
        route: "/payment-cancelation-refund-policy"
    }
]

function Footer() {
    return (
        <div className="footer">
            <div className="section-1">
                <Link to="/" className="company-logo">
                    <img src="https://res.cloudinary.com/emacon-production/image/upload/v1638523275/the-outlet/Artboard_7_copy_6png_ntfffb.png" alt="The Outlet" />
                </Link>
                <p>Address: The Outlet, Nairobi, Kenya</p>
                <p>Email: info@theoutlet.com </p>
                <p>Phone number: +254 712 345678</p>
            </div>

            <div className="section-2">
                {
                    policies.map((item, index) => <Link key={index} to={item.route} className="policy_link" >{item.policy}</Link>)
                }
            </div>

            <div className="section-3">
                {
                    socialIcons.map((item, index) => (
                        <a href={item.targetLink} key={index} target="_blank" className="icon-link" rel="noreferrer">
                            <i className={item.icon}/>
                        </a>
                    ))
                }
            </div>
        </div>
    )
}

export default Footer
